module.exports = __webpack_public_path__ + "media/application/images/ui/checkbox-7c8804a88d9eea5b77abafce6b7a4016.png";